import type { InputHTMLAttributes, ReactNode } from 'react';

import type { Theme } from 'ui/theme';

export type RadioSize = keyof Theme['fontSizes'];

export type RadioProps = InputHTMLAttributes<HTMLInputElement> & {
  children: ReactNode;
  onChange?: (string) => void;
  selectedValue?: string;
  size?: RadioSize;
};

export enum RADIO_CONST {
  TEST_ID = 'radio',
}
